import { useBrowserTitle } from '@acp/core-ui';
import DashboardPage from '../features/dashboard/page';

export function Dashboard() {
    useBrowserTitle('Dashboard');

    // TODO: Lazy load at some point
    return (
        <DashboardPage />
    );
}
